<script lang="ts">
	import type { BlogBlock } from '$models/Block/BlogBlock';
	import type { Component } from 'svelte';
	import CopyBlock from '$components/Block/CopyBlock.svelte';
	import VisualBlock from '$components/Block/VisualBlock.svelte';

	let { block }: { block: BlogBlock } = $props();

	const blockComponents: Record<string, Component<any>> = {
		copy: CopyBlock,
		visual: VisualBlock
	};

	let blockComponent = $derived(blockComponents[block.type] ?? null);
</script>

{#if blockComponent}
	{@const BlockComponent = blockComponent}
	<div class="block block--blog">
		<div class="block-container container container-small">
			<BlockComponent {block} />
		</div>
	</div>
{/if}
